import { AbstractControl, ValidationErrors } from '@angular/forms';

// Regular expressions for password validation
const regexNumeric = /[0-9]/;
const regexSpecial = /[!@#\$.-]/;
const sequentialRegex = /(\w)\1{3,}/;
const repeatedRegex = /(\w{4})\1+/;
const regexMonific = /.*monific.*/;
const regexConsecutiveAlphabet = /(abcd|bcde|cdef|defg|efgh|fghi|ghij|hijk|ijkl|jklm|klmn|lmno|mnop|nopq|opqr|pqrs|qrst|rstu|stuv|tuvw|uvwx|vwxy|wxyz)/i;
const regexConsecutiveNumbers = /(0123|1234|2345|3456|4567|5678|6789|9876|8765|7654|6543|5432|4321|3210)/;
const regexLowercase = /[a-z]/; // Verifica letras minúsculas
const regexUppercase = /[A-Z]/; // Verifica letras mayúsculas

/**
 * Utility function to test a regular expression against a value.
 * @param value - The value to test.
 * @param regex - The regular expression to use for testing.
 * @returns True if the regular expression matches the value, false otherwise.
 */
function testRegex(value: string, regex: RegExp): boolean {
   return regex.test(value);
}

/**
 * A class containing text validation functions for Angular forms.
 */
export class TextValidators {
   /**
    * Validates the password control to ensure it meets the specified requirements.
    * @param control - The AbstractControl representing the password control.
    * @returns A ValidationErrors object if the password is invalid, or null if it is valid.
    */
   static password(control: AbstractControl): ValidationErrors | null {
     const passwordValue: string = control.value.trim();
     let errors = {};

     // Longitud minima 8 caracteres
     if (passwordValue.length < 8) {
       errors = {...errors, minLengthRequired: true };
     }
     
     // Debe contener al menos una letra minúscula
     if (!testRegex(passwordValue, regexLowercase)) {
       errors = {...errors, lowercaseMissing: true };
     }

     // Debe contener al menos una letra mayúscula
     if (!testRegex(passwordValue, regexUppercase)) {
       errors = {...errors, uppercaseMissing: true };
     }

     // Maxima longitud 40 caracteres
     if (passwordValue.length > 41) {
       errors = {...errors, maxLengthViolation: true };
     }

     // Debe contener al menos un numero
     if (!testRegex(passwordValue, regexNumeric)) {
       errors = {...errors, numericCharacterMissing: true };
     }

     // Debe contener al menos un caracter especial
     if (!testRegex(passwordValue, regexSpecial)) {
       errors = {...errors, specialCharacterMissing: true };
     }

     // No puede contener mas de 4 caracteres iguales consecutivos
     if (testRegex(passwordValue, sequentialRegex)) {
       errors = {...errors, sequentialCharacters: true };
     }

     // No puede contener secuencias consecutivas de cuatro letras del abecedario
     if (testRegex(passwordValue, regexConsecutiveAlphabet)) {
       errors = {...errors, consecutiveAlphabet: true };
     }

     // No puede contener secuencias consecutivas de cuatro números
     if (testRegex(passwordValue, regexConsecutiveNumbers)) {
       errors = {...errors, consecutiveNumbers: true };
     }

     // No puede contener caracteres consecutivos
     if (testRegex(passwordValue, repeatedRegex)) {
       errors = {...errors, repeatedCharacters: true };
     }

     const passwordLowerCase: string = passwordValue.toLowerCase();

     // No puede contener la palabra monific
     if (testRegex(passwordLowerCase, regexMonific)) {
        errors = {...errors, containsMonific: true };
     }
     
     return errors;
   }
}
